import React from "react";

function Navbar(){

const name = localStorage.getItem("name") || "User";
const role = localStorage.getItem("role") || "";

const formattedRole =
role === "master_admin"
? "Master Admin"
: role === "admin"
? "Admin"
: "";

const logout = () => {

localStorage.removeItem("token");
localStorage.removeItem("name");
localStorage.removeItem("role");

window.location.reload();

};

return(

<div style={navbar}>

<div style={title}>
Admin Panel
</div>

<div style={rightSection}>

<div style={userBox}>
<span style={userText}>
Logged in as
</span>

<span style={userName}>
{name}
</span>

<span style={roleBadge}>
{formattedRole}
</span>
</div>

<button
style={logoutBtn}
onClick={logout}
>
Logout
</button>

</div>

</div>

);

}


/* ---------- UI STYLES ---------- */

const navbar = {

width:"100%",
height:"60px",
background:"#f8f9fa",
display:"flex",
alignItems:"center",
justifyContent:"space-between",
padding:"0 25px",
borderBottom:"1px solid #e5e5e5",
boxSizing:"border-box"

};

const title = {

fontSize:"20px",
fontWeight:"600",
color:"#2c3e50"

};

const rightSection = {

display:"flex",
alignItems:"center",
gap:"20px"

};

const userBox = {

display:"flex",
alignItems:"center",
gap:"8px"

};

const userText = {

fontSize:"14px",
color:"#666"

};

const userName = {

fontSize:"14px",
fontWeight:"600",
color:"#2c3e50"

};

const roleBadge = {

background:"#2563eb",
color:"#fff",
fontSize:"12px",
padding:"3px 8px",
borderRadius:"5px"

};

const logoutBtn = {

background:"#e74c3c",
color:"#fff",
border:"none",
padding:"8px 14px",
borderRadius:"5px",
cursor:"pointer",
fontSize:"14px"

};

export default Navbar;